export const uk_labels_ap = {
    'file_input_button_label' : 'Вибрати файл',
    'remove_confirm_text' : 'Ви бажаєте видалити інформацію?',
    'remove_error' : 'Інформацію не вдалося видалити',
    'remove_success' : 'Інформацію успішно видалено',
    'save_error' : 'Дані не вдалося зберегти. Перевірте чи заповнено усі необхідні поля.',
    'save_success' : 'Дані були успішно збережені',

    /* about us */
    /* categories */
    'auc_section_title' : 'Про нас | Категорії',
    'auc_add_new_button_label' : 'Додати категорію',
    'auc_add_new_popup_title' : 'Додати нову категорію',
    'auc_edit_popup_title' : 'Внесення змін в категорію',
    'auc_form_image_input_label' : 'Зображення (при необхідності)',
    'auc_form_name_input_label' : 'Назва',
    'auc_form_position_input_label' : 'Позиція',
    'auc_form_description_input_label' : 'Опис',
    'auc_form_active_input_label' : 'Відображати на сайті',
    'auc_table_head_position_label' : 'Позиція',
    'auc_form_update_button_label' : 'Зберегти зміни',
    'auc_form_add_button_label' : 'Додати',
    'auc_table_head_id_label' : 'Ід',
    'auc_table_head_name_label' : 'Назва',
    'auc_table_head_active_label' : 'Відображається',
    'auc_table_empty_list_message' : 'Даних для відображення не знайдено',
    'auc_table_body_active_yes_label' : 'Так',
    'auc_table_body_active_not_label' : 'Ні',
    'auc_edit_button_title' : 'Внести зміни в даний розділ',
    'auc_delete_button_title' : 'Видалити даний розділ',

    /* about us */
    /* posts */
    'aup_section_title' : 'Про нас | Статті',
    'aup_add_new_button_label' : 'Додати статтю',
    'aup_add_new_popup_title' : 'Додати нову статтю',
    'aup_edit_popup_title' : 'Внесення змін в статтю',
    'aup_table_head_id_label' : 'Ід',
    'aup_table_head_name_label' : 'Назва',
    'aup_table_head_type_label' : 'Категорія',
    'aup_table_head_active_label' : 'Відображається',
    'aup_table_head_position_label' : 'Позиція',
    'aup_form_image_input_label' : 'Зображення (при необхідності)',
    'aup_form_title_input_label' : 'Назва',
    'aup_form_type_id_input_label' : 'Категорія',
    'aup_form_type_id_empty_opt' : 'Виберіть варіант',
    'aup_form_content_input_label' : 'Контент',
    'aup_form_position_input_label' : 'Позиція',
    'aup_form_active_input_label' : 'Відображати на сайті',
    'aup_form_update_button_label' : 'Зберегти зміни',
    'aup_form_add_button_label' : 'Додати статтю',
    'aup_table_empty_list_message' : 'Даних для відображення не знайдено',
    'aup_table_body_active_yes_label' : 'Так',
    'aup_table_body_active_not_label' : 'Ні',
    'aup_edit_button_title' : 'Внести зміни в дану статтю',
    'aup_delete_button_title' : 'Видалити дану статтю',

    /* vacancies */
    /* categories */
    'vc_section_title' : 'Вакансії | Категорії',
    'vc_add_new_button_label' : 'Додати нову категорію',
    'vc_edit_popup_title' : 'Внести зміни в категорію',
    'vc_add_new_popup_title' : 'Додати нову категорію',
    'vc_form_title_input_label' : 'Назва',
    'vc_form_description_input_label' : 'Опис',
    'vc_form_active_input_label' : 'Відображати на сайті',
    'vc_form_update_button_label' : 'Зберегти внесені зміни',
    'vc_form_add_button_label' : 'Додати категорію',
    'vc_table_empty_list_message' : 'Даних для відображення не знайдено',
    'vc_table_body_active_yes_label' : 'Так',
    'vc_table_body_active_not_label' : 'Ні',
    'vc_edit_button_title' : 'Внести зміни в дану категорію',
    'vc_delete_button_title' : 'Видалити дану категорію',
    'vc_table_head_id_label' : 'Ід',
    'vc_table_head_name_label' : 'Назва',
    'vc_table_head_active_label' : 'Відображається',

    /* vacancies */
    /* posts */
    'vp_section_title' : 'Вакансії | Список',
    'vp_add_new_button_label' : 'Додати вакансію',
    'vp_edit_popup_title' : 'Внесення змін в вакансію',
    'vp_add_new_popup_title' : 'Додати нову вакансію',
    'vp_form_type_id_empty_opt' : 'Виберіть варіант',
    'vp_form_image_input_label' : 'Зображення (при необхідності)',
    'vp_form_title_input_label' : 'Заголовок',
    'vp_form_type_id_input_label' : 'Категорія',
    'vp_form_content_input_label' : 'Контент',
    'vp_form_active_input_label' : 'Відображати на сайті',
    'vp_form_update_button_label' : 'Зберегти внесені зміни',
    'vp_form_add_button_label' : 'Додати вакансію',
    'vp_table_empty_list_message' : 'Даних для відображення не знайдено',
    'vp_table_head_id_label' : 'Ід',
    'vp_table_head_name_label' : 'Назва',
    'vp_table_head_type_label' : 'Категорія',
    'vp_table_head_active_label' : 'Відображається',
    'vp_table_body_active_yes_label' : 'Так',
    'vp_table_body_active_not_label' : 'Ні',
    'vp_edit_button_title' : 'Внести зміни в вакансію',
    'vp_delete_button_title' : 'Видалити вакансію',

    /* transportation to order */
    /* categories */
    'ttoc_section_title' : 'Послуги | Список категорій',
    'ttoc_add_new_button_label' : 'Додати нову категорію',
    'ttoc_edit_popup_title' : 'Внесення змін в категорію',
    'ttoc_add_new_popup_title' : 'Додати нову категорію',
    'ttoc_form_image_input_label' : 'Зображення (при необхідності)',
    'ttoc_form_title_input_label' : 'Назва',
    'ttoc_form_description_input_label' : 'Опис',
    'ttoc_form_position_input_label' : 'Позиція',
    'ttoc_form_active_input_label' : 'Відображати на сайті',
    'ttoc_form_update_button_label' : 'Зберегти внесені зміни',
    'ttoc_form_add_button_label' : 'Додати категорію',
    'ttoc_table_empty_list_message' : 'Даних для відображення не знайдено',
    'ttoc_table_head_id_label' : 'Ід',
    'ttoc_table_head_name_label' : 'Назва',
    'ttoc_table_head_active_label' : 'Відображається',
    'ttoc_table_head_position_label' : 'Позиція',
    'ttoc_table_body_active_yes_label' : 'Так',
    'ttoc_table_body_active_not_label' : 'Ні',
    'ttoc_edit_button_title' : 'Внести зміни в категорію',
    'ttoc_delete_button_title' : 'Видалити категорію',

    /* transportation to order */
    /* posts */
    'ttop_section_title' : 'Послуги | Записи',
    'ttop_add_new_button_label' : 'Додати нову статтю',
    'ttop_edit_popup_title' : 'Внесення змін в статтю',
    'ttop_add_new_popup_title' : 'Додати нову статтю',
    'ttop_form_type_id_empty_opt' : 'Виберіть варіант',
    'ttop_form_image_input_label' : 'Зображення (при необхідності)',
    'ttop_form_title_input_label' : 'Назва',
    'ttop_form_type_id_input_label' : 'Категорія',
    'ttop_form_description_input_label' : 'Контенті',
    'ttop_form_position_input_label' : 'Позиція',
    'ttop_form_active_input_label' : 'Відображати на сайті',
    'ttop_form_update_button_label' : 'Зберегти внесені зміни',
    'ttop_form_add_button_label' : 'Додати категорію',
    'ttop_table_head_id_label' : 'Ід',
    'ttop_table_head_name_label' : 'Назва',
    'ttop_table_head_type_label' : 'Категорія',
    'ttop_table_head_active_label' : 'Відображається',
    'ttop_table_head_position_label' : 'Позиція',
    'ttop_table_empty_list_message' : 'Даних для відображення не знайдено',
    'ttop_table_body_active_yes_label' : 'Так',
    'ttop_table_body_active_not_label' : 'Ні',
    'ttop_edit_button_title' : 'Внести зміни в статтю',
    'ttop_delete_button_title' : 'Видалити статтю',

    /* road to airport */
    /* categories */
    'rtac_section_title' : 'Дорога до аеропорту | Категорії',
    'rtac_add_new_button_label' : 'Додати нову категорію',
    'rtac_add_new_popup_title' : 'Дадати нову категорію',
    'rtac_edit_popup_title' : 'Внесення змін в категорію',
    'rtac_form_image_input_label' : 'Зображення (при необхідності)',
    'rtac_form_title_input_label' : 'Назва',
    'rtac_form_description_input_label' : 'Опис',
    'rtac_form_position_input_label' : 'Позиція',
    'rtac_form_active_input_label' : 'Відображати на сайті',
    'rtac_form_update_button_label' : 'Зберегти внесені зміни',
    'rtac_form_add_button_label' : 'Додати категорію',
    'rtac_table_head_id_label' : 'Ід',
    'rtac_table_head_name_label' : 'Назва',
    'rtac_table_head_active_label' : 'Відображається',
    'rtac_table_head_position_label' : 'Позиція',
    'rtac_table_empty_list_message' : 'Даних для відображення не знайдено',
    'rtac_table_body_active_yes_label' : 'Так',
    'rtac_table_body_active_not_label' : 'Ні',
    'rtac_edit_button_title' : 'Внести зміни в категорію',
    'rtac_delete_button_title' : 'Видалити категорію',

    /* road to airport */
    /* records */
    'rtar_section_title' : 'Дорога до аеропорту | Статті',
    'rtar_add_new_button_label' : 'Додати нову статтю',
    'rtar_edit_popup_title' : 'Внесення змін в статтю',
    'rtar_add_new_popup_title' : 'Дадати нову статтю',
    'rtar_form_image_input_label' : 'Зображення (при необхідності)',
    'rtar_form_title_input_label' : 'Назва',
    'rtar_form_type_id_input_label' : 'Категорія',
    'rtar_form_type_id_input_empty_row' : 'Виберіть категорію',
    'rtar_form_description_input_label' : 'Контент',
    'rtar_form_position_input_label' : 'Позиція',
    'rtar_form_active_input_label' : 'Відображати на сайті',
    'rtar_form_add_button_label' : 'Додати статтю',
    'rtar_form_update_button_label' : 'Зберегти внесені зміни',
    'rtar_table_head_id_label' : 'Ід',
    'rtar_table_head_name_label' : 'Назва',
    'rtar_table_head_category_label' : 'Категорія',
    'rtar_table_head_active_label' : 'Відображається',
    'rtar_table_head_position_label' : 'Позиція',
    'rtar_table_body_active_yes_label' : 'Так',
    'rtar_table_body_active_not_label' : 'Ні',
    'rtar_edit_button_title' : 'Внести зміни в статтю',
    'rtar_delete_button_title' : 'Видалити статтю',

    /* international projects */
    /* categories */
    'ipc_section_title' : 'Міжнародні проекти | Категорії',
    'ipc_add_new_button_label' : 'Додати категорію',
    'ipc_add_new_popup_title' : 'Додати нову категорію',
    'ipc_edit_popup_title' : 'Внесення змін в категорію',
    'ipc_form_image_input_label' : 'Зображення (при необхідності)',
    'ipc_form_title_input_label' : 'Назва',
    'ipc_form_description_input_label' : 'Опис',
    'ipc_form_position_input_label' : 'Позиція',
    'ipc_form_active_input_label' : 'Відображати на сайті',
    'ipc_form_update_button_label' : 'Зберегти внесені зміни',
    'ipc_form_add_button_label' : 'Додати категорію',
    'ipc_table_head_id_label' : 'Ід',
    'ipc_table_head_name_label' : 'Назва',
    'ipc_table_head_active_label' : 'Відображається',
    'ipc_table_head_position_label' : 'Позиція',
    'ipc_table_empty_list_message' : 'Даних для відображення не знайдено',
    'ipc_table_body_active_yes_label' : 'Так',
    'ipc_table_body_active_not_label' : 'Ні',
    'ipc_edit_button_title' : 'Внести зміни в категорію',
    'ipc_delete_button_title' : 'Видалити категорію',

    /* international projects */
    /* records */
    'ipr_section_title' : 'Міжнародні проекти | Статті',
    'ipr_add_new_button_label' : 'Додати нову статтю',
    'ipr_edit_popup_title' : 'Внесення змін в статтю',
    'ipr_add_new_popup_title' : 'Дадати нову статтю',
    'ipr_form_image_input_label' : 'Зображення (при необхідності)',
    'ipr_form_title_input_label' : 'Назва',
    'ipr_form_type_id_input_label' : 'Категорія',
    'ipr_form_type_id_input_empty_row' : 'Виберіть категорію',
    'ipr_form_description_input_label' : 'Контент',
    'ipr_form_position_input_label' : 'Позиція',
    'ipr_form_active_input_label' : 'Відображати на сайті',
    'ipr_form_add_button_label' : 'Додати статтю',
    'ipr_form_update_button_label' : 'Зберегти внесені зміни',
    'ipr_table_head_id_label' : 'Ід',
    'ipr_table_head_name_label' : 'Назва',
    'ipr_table_head_category_label' : 'Категорія',
    'ipr_table_head_active_label' : 'Відображається',
    'ipr_table_head_position_label' : 'Позиція',
    'ipr_table_body_active_yes_label' : 'Так',
    'ipr_table_body_active_not_label' : 'Ні',
    'ipr_edit_button_title' : 'Внести зміни в статтю',
    'ipr_delete_button_title' : 'Видалити статтю',

    /* information for tourists */
    /* categories */
    'iftc_section_title' : 'Інформація для туристів | Категорії',
    'iftc_add_new_button_label' : 'Додати категорію',
    'iftc_add_new_popup_title' : 'Додати нову категорію',
    'iftc_edit_popup_title' : 'Внесення змін в категорію',
    'iftc_form_image_input_label' : 'Зображення (при необхідності)',
    'iftc_form_title_input_label' : 'Назва',
    'iftc_form_description_input_label' : 'Опис',
    'iftc_form_position_input_label' : 'Позиція',
    'iftc_form_active_input_label' : 'Відображати на сайті',
    'iftc_form_update_button_label' : 'Зберегти внесені зміни',
    'iftc_form_add_button_label' : 'Додати категорію',
    'iftc_table_head_id_label' : 'Ід',
    'iftc_table_head_name_label' : 'Назва',
    'iftc_table_head_active_label' : 'Відображається',
    'iftc_table_head_position_label' : 'Позиція',
    'iftc_table_empty_list_message' : 'Даних для відображення не знайдено',
    'iftc_table_body_active_yes_label' : 'Так',
    'iftc_table_body_active_not_label' : 'Ні',
    'iftc_edit_button_title' : 'Внести зміни в категорію',
    'iftc_delete_button_title' : 'Видалити категорію',

    /* information for tourists */
    /* records */
    'iftr_section_title' : 'Інформація для туристів | Статті',
    'iftr_add_new_button_label' : 'Додати нову статтю',
    'iftr_edit_popup_title' : 'Внесення змін в статтю',
    'iftr_add_new_popup_title' : 'Дадати нову статтю',
    'iftr_form_image_input_label' : 'Зображення (при необхідності)',
    'iftr_form_title_input_label' : 'Назва',
    'iftr_form_type_id_input_label' : 'Категорія',
    'iftr_form_type_id_input_empty_row' : 'Виберіть категорію',
    'iftr_form_description_input_label' : 'Контент',
    'iftr_form_position_input_label' : 'Позиція',
    'iftr_form_active_input_label' : 'Відображати на сайті',
    'iftr_form_add_button_label' : 'Додати статтю',
    'iftr_form_update_button_label' : 'Зберегти внесені зміни',
    'iftr_table_head_id_label' : 'Ід',
    'iftr_table_head_name_label' : 'Назва',
    'iftr_table_head_category_label' : 'Категорія',
    'iftr_table_head_active_label' : 'Відображається',
    'iftr_table_head_position_label' : 'Позиція',
    'iftr_table_empty_list_message' : 'Даних для відображення не знайдено',
    'iftr_table_body_active_yes_label' : 'Так',
    'iftr_table_body_active_not_label' : 'Ні',
    'iftr_edit_button_title' : 'Внести зміни в статтю',
    'iftr_delete_button_title' : 'Видалити статтю',

    /* electricity supply */
    /* categories */
    'esc_section_title' : 'Постачання електроенергії | Категорії',
    'esc_add_new_button_label' : 'Додати категорію',
    'esc_add_new_popup_title' : 'Додати нову категорію',
    'esc_edit_popup_title' : 'Внесення змін в категорію',
    'esc_form_image_input_label' : 'Зображення (при необхідності)',
    'esc_form_title_input_label' : 'Назва',
    'esc_form_description_input_label' : 'Опис',
    'esc_form_position_input_label' : 'Позиція',
    'esc_form_active_input_label' : 'Відображати на сайті',
    'esc_form_update_button_label' : 'Зберегти внесені зміни',
    'esc_form_add_button_label' : 'Додати категорію',
    'esc_table_head_id_label' : 'Ід',
    'esc_table_head_name_label' : 'Назва',
    'esc_table_head_active_label' : 'Відображається',
    'esc_table_head_position_label' : 'Позиція',
    'esc_table_empty_list_message' : 'Даних для відображення не знайдено',
    'esc_table_body_active_yes_label' : 'Так',
    'esc_table_body_active_not_label' : 'Ні',
    'esc_edit_button_title' : 'Внести зміни в категорію',
    'esc_delete_button_title' : 'Видалити категорію',

    /* electricity supply */
    /* records */
    'esp_section_title' : 'Постачання електроенергії | Статті',
    'esp_add_new_button_label' : 'Додати нову статтю',
    'esp_edit_popup_title' : 'Внесення змін в статтю',
    'esp_add_new_popup_title' : 'Дадати нову статтю',
    'esp_form_image_input_label' : 'Зображення (при необхідності)',
    'esp_form_title_input_label' : 'Назва',
    'esp_form_type_id_input_label' : 'Категорія',
    'esp_form_type_id_input_empty_row' : 'Виберіть категорію',
    'esp_form_description_input_label' : 'Контент',
    'esp_form_position_input_label' : 'Позиція',
    'esp_form_active_input_label' : 'Відображати на сайті',
    'esp_form_add_button_label' : 'Додати статтю',
    'esp_form_update_button_label' : 'Зберегти внесені зміни',
    'esp_table_head_id_label' : 'Ід',
    'esp_table_head_name_label' : 'Назва',
    'esp_table_head_category_label' : 'Категорія',
    'esp_table_head_active_label' : 'Відображається',
    'esp_table_head_position_label' : 'Позиція',
    'esp_table_empty_list_message' : 'Даних для відображення не знайдено',
    'esp_table_body_active_yes_label' : 'Так',
    'esp_table_body_active_not_label' : 'Ні',
    'esp_edit_button_title' : 'Внести зміни в статтю',
    'esp_delete_button_title' : 'Видалити статтю',

    /* road situation */
    /* categories */
    'rsc_section_title' : 'Ситуація на дорозі | Категорії',
    'rsc_add_new_button_label' : 'Додати категорію',
    'rsc_add_new_popup_title' : 'Додати нову категорію',
    'rsc_edit_popup_title' : 'Внесення змін в категорію',
    'rsc_form_title_input_label' : 'Назва',
    'rsc_form_description_input_label' : 'Опис',
    'rsc_form_active_input_label' : 'Відображати на сайті',
    'rsc_form_update_button_label' : 'Зберегти внесені зміни',
    'rsc_form_add_button_label' : 'Додати категорію',
    'rsc_table_head_id_label' : 'Ід',
    'rsc_table_head_name_label' : 'Назва',
    'rsc_table_head_active_label' : 'Відображається',
    'rsc_table_empty_list_message' : 'Даних для відображення не знайдено',
    'rsc_table_body_active_yes_label' : 'Так',
    'rsc_table_body_active_not_label' : 'Ні',
    'rsc_edit_button_title' : 'Внести зміни в категорію',
    'rsc_delete_button_title' : 'Видалити категорію',

    /* settings */
    'settings_section_title' : 'Налаштування',
    'settings_table_header_name_label' : 'Назва',
    'settings_tbody_contact_page_label' : 'Контент сторінки "Контакти"',
    'settings_tbody_schedules_page_label' : 'Контент сторінки "Розклад руху"',
    'settings_tbody_online_map_page_label' : 'Контент сторінки "Відстеження онлайн"',
    'settings_tbody_home_page_label' : 'Контент сторінки "Головна"',
    'settings_tbody_edit_button' : 'Внести зміни',
    'settings_form_content_label' : 'Вміст',
    'settings_form_save_button_label' : 'Зберегти',

    /* tickets */
    /* categories */
    'tickets_cat_section_title' : 'Квитки | Категорії',
    'tickets_cat_add_new_button_label' : 'Додати категорію',
    'tickets_cat_add_new_popup_title' : 'Додати нову категорію',
    'tickets_cat_edit_popup_title' : 'Внесення змін в категорію',
    'tickets_cat_form_image_input_label' : 'Зображення (при необхідності)',
    'tickets_cat_form_title_input_label' : 'Назва',
    'tickets_cat_form_description_input_label' : 'Опис',
    'tickets_cat_form_position_input_label' : 'Позиція',
    'tickets_cat_form_active_input_label' : 'Відображати на сайті',
    'tickets_cat_form_update_button_label' : 'Зберегти внесені зміни',
    'tickets_cat_form_add_button_label' : 'Додати категорію',
    'tickets_cat_table_head_id_label' : 'Ід',
    'tickets_cat_table_head_name_label' : 'Назва',
    'tickets_cat_table_head_active_label' : 'Відображається',
    'tickets_cat_table_head_position_label' : 'Позиція',
    'tickets_cat_table_empty_list_message' : 'Даних для відображення не знайдено',
    'tickets_cat_table_body_active_yes_label' : 'Так',
    'tickets_cat_table_body_active_not_label' : 'Ні',
    'tickets_cat_edit_button_title' : 'Внести зміни в категорію',
    'tickets_cat_delete_button_title' : 'Видалити категорію',

    /* tickets */
    /* records */
    'tickets_post_section_title' : 'Квитки | Статті',
    'tickets_post_add_new_button_label' : 'Додати нову статтю',
    'tickets_post_edit_popup_title' : 'Внесення змін в статтю',
    'tickets_post_add_new_popup_title' : 'Дадати нову статтю',
    'tickets_post_form_image_input_label' : 'Зображення (при необхідності)',
    'tickets_post_form_title_input_label' : 'Назва',
    'tickets_post_form_type_id_input_label' : 'Категорія',
    'tickets_post_form_type_id_input_empty_row' : 'Виберіть категорію',
    'tickets_post_form_description_input_label' : 'Контент',
    'tickets_post_form_position_input_label' : 'Позиція',
    'tickets_post_form_active_input_label' : 'Відображати на сайті',
    'tickets_post_form_add_button_label' : 'Додати статтю',
    'tickets_post_form_update_button_label' : 'Зберегти внесені зміни',
    'tickets_post_table_head_id_label' : 'Ід',
    'tickets_post_table_head_name_label' : 'Назва',
    'tickets_post_table_head_category_label' : 'Категорія',
    'tickets_post_table_head_active_label' : 'Відображається',
    'tickets_post_table_head_position_label' : 'Позиція',
    'tickets_post_table_empty_list_message' : 'Даних для відображення не знайдено',
    'tickets_post_table_body_active_yes_label' : 'Так',
    'tickets_post_table_body_active_not_label' : 'Ні',
    'tickets_post_edit_button_title' : 'Внести зміни в статтю',
    'tickets_post_delete_button_title' : 'Видалити статтю'
}